import { defineMessages } from 'react-intl';

export const threadFooterMessages = defineMessages({
  answer: { defaultMessage: 'Reply to the topic', id: 'fvCCJ3' },
  newMessage: { defaultMessage: 'New message', id: 'BOGA9j' },
  replyToThreadAuthor: {
    defaultMessage: '<styledSpan>Reply to </styledSpan> {authorWithAvatar}',
    id: 'gDbFvX',
  },
  backButtonLabel: { defaultMessage: 'Discussion', id: '20bImY' },
  answerTo: { defaultMessage: "You're answering to", id: 'eBjONv' },
});
